// extracted by mini-css-extract-plugin
export default {"root":"MGuBVsD3Tz64UzZfit4u","not-available":"sD47btrAML5uex1sGvbO","notAvailable":"sD47btrAML5uex1sGvbO"};